<template>
  <div v-if="resultados.length > 0">
    <div
      class="gilmer text-uppercase text-azul h4 font-weight-bold px-3 px-lg-0 pt-3 pt-lg-0"
    >
      {{ titulo }}
    </div>
    <div class="text-black-50 px-3 px-lg-0 h6">
      {{ texto1 }}
      <strong>{{ destacado }}</strong>
      {{ texto2 }}
    </div>
    <div class="px-3 px-lg-0 mt-4">
      <ItemPostulanteResultado
        v-for="resultado in resultados"
        :key="resultado.id"
        :resultado="resultado"
      />
    </div>
  </div>
</template>

<script>
import ItemPostulanteResultado from "@/components/postulante/ItemPostulanteResultado";
export default {
  components: {
    ItemPostulanteResultado
  },
  props: ["resultados", "texto1", "destacado", "texto2", "titulo"]
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/postulante/SeccionResultado.vue